import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a98702a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "app-header__logo" }
const _hoisted_3 = ["href"]

import { storeToRefs } from 'pinia';
import { useCommonStore } from '@/store/common';

import MultiMenu from '@/components/common/MultiMenu/MultiMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {


const { params } = storeToRefs(useCommonStore());


return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_inline_svg, {
        src: require('@/assets/icons/IconAILogoWhite.svg')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_v_spacer),
    _createVNode(MultiMenu),
    _createElementVNode("a", {
      href: `https://app.24ai.tech/${_unref(params)?.lang}`,
      class: "button",
      target: "_blank"
    }, _toDisplayString(_ctx.$t('common.go-to-app')), 9, _hoisted_3)
  ]))
}
}

})